import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTableRow = () => {
  return (
    <g>
      <path d="M16 5.5h-.005l-.012 9.451c0 .541-.41.986-.936 1.043l-.114.006H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95V1.05C0 .509.41.063.936.006L1.05 0h13.9c.54 0 .986.41 1.043.936L16 1.05 15.996 4H16v1.5zm-13.144-4H1.5v2.194L2.856 1.5zm11.638 4H1.5v9h12.984l.01-9zm-8.287-4H4.498L2.953 4h1.709l1.545-2.5zm3.299 0H7.849L6.304 4h1.657l1.545-2.5zm3.35 0h-1.708L9.603 4h1.708l1.545-2.5zm1.64 2.5.003-2.5L12.953 4h1.543z" />
    </g>
  );
};

export default withIcon(IconTableRow);
